import { motion } from "framer-motion";
import { StarSolidIcon } from "../../utils/icons";

// Testimonial data array - Each object represents a customer testimonial
const testimonials = [
  {
    id: 1,
    name: "Annabelle Antwi",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1743031178/maintenance_kaa3kh.webp",
    content:
      "The Moisture Lock  has completely transformed my hair care routine. My curls have never been more defined and hydrated!",
    rating: 5,
  },
  {
    id: 2,
    name: "Abena Serwaa",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1743031212/permed_hair_qerzau.webp",
    content:
      "I've tried many hair products, but Acquwaa Naturals stands out for its quality and effectiveness. The Liquid Gold is a game-changer!",
    rating: 5,
  },
  {
    id: 3,
    name: "Sherifa Alhassan",
    image:
      "https://res.cloudinary.com/dmxzxo1fk/image/upload/v1743030996/3a-3c_kq8u1f.webp",
    content:
      "As a professional hairstylist, I highly recommend these products to my clients. The results speak for themselves - healthy, beautiful hair.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-[#DB5461]/10 to-transparent" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-1.5 mb-4 text-sm font-medium tracking-wider text-gold-500 bg-gold-50 rounded-full">
            TESTIMONIALS
          </span>
          <h2 className="text-4xl font-serif font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <div className="w-24 h-1 bg-[#DB5461] mx-auto rounded-full" />
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              whileHover={{ y: -8 }}
              className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              {/* Profile Image with Star Badge */}
              <div className="relative mb-8">
                <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
                  <div className="relative">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-20 h-20 rounded-full object-cover border-4 border-white shadow-lg"
                    />
                    <div className="absolute -bottom-2 -right-2 bg-[#DB5461] rounded-full p-1.5 border-2 border-white">
                      <StarSolidIcon className="h-5 w-5 text-[#DB5461]" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Customer Name and Role */}
              <div className="text-center mb-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {testimonial.name}
                </h3>
              </div>

              {/* Rating Stars */}
              <div className="flex justify-center mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <StarSolidIcon
                    key={i}
                    className="w-5 h-5 text-[#DB5461] mx-0.5"
                  />
                ))}
              </div>

              {/* Testimonial Content with Decorative Quotes */}
              <div className="relative">
                {/* Opening quote */}
                <svg
                  className="absolute -top-3 -left-3 w-6 h-6 text-[#DB5461]/40"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
                <p className="text-gray-600 text-center italic relative z-10 px-6">
                  {testimonial.content}
                </p>
                {/* Closing quote */}
                <svg
                  className="absolute -bottom-3 -right-3 w-6 h-6 text-[#DB5461]/40"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h9.983zm14.017 0v7.391c0 5.704-3.748 9.57-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z" />
                </svg>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
